<template>
    <div class="flex items-center" @keydown.enter.prevent>
        <span data-cy="file-name">
            {{ props.params.value }}
        </span>
    </div>
</template>

<script setup lang="ts">

const props = defineProps({
    params: {
        type: Object as () => {
            api: any,
            node: any,
            column: any,
            value: string
        },
        required: true
    }
})


</script>

<style scoped>

</style>